import React, { useCallback } from 'react'

import { Pressable, Stack } from '@zet/design-system'
import { B16 } from '@zet/integration-flow/components/typography'

import Checkbox from '../../../assets/svg/Checkbox'
import CheckboxJfs from '../../../assets/svg/Checkboxjfs'

interface FilterItem {
  key: string
  displayText: string
}

interface FilterData {
  values?: FilterItem[]
}

interface BrandFilterListProps {
  data: FilterData
  selectedFilters: string[]
  onFilterChange: (brandKey: string, isSelected: boolean) => void
}

const BrandFilterItem = React.memo<{
  item: FilterItem
  isSelected: boolean
  onToggle: (key: string) => void
}>(({ item, isSelected, onToggle }) => {
  const handlePress = useCallback(() => {
    onToggle(item.key)
  }, [item.key, onToggle])

  return (
    <Pressable
      className="flex-row items-center justify-between my-2"
      onPress={handlePress}
    >
      <B16>{item.displayText}</B16>
      {isSelected ? (
        <CheckboxJfs width={24} height={24} className="mr-2" />
      ) : (
        <Checkbox width={24} height={24} className="mr-2" />
      )}
    </Pressable>
  )
})

BrandFilterItem.displayName = 'BrandFilterItem'

export const BrandFilterList: React.FC<BrandFilterListProps> = React.memo(
  ({ data, selectedFilters, onFilterChange }) => {
    const handleToggle = useCallback(
      (itemKey: string) => {
        const isSelected = selectedFilters.includes(itemKey)
        onFilterChange(itemKey, isSelected)
      },
      [selectedFilters, onFilterChange],
    )

    return (
      <Stack>
        {data?.values?.map((item) => (
          <BrandFilterItem
            key={item.key}
            item={item}
            isSelected={selectedFilters.includes(item.key)}
            onToggle={handleToggle}
          />
        ))}
      </Stack>
    )
  },
)

BrandFilterList.displayName = 'BrandFilterList'
